<ng-container
  *ngIf="globalService.page != 'purchase-steps'; else purchaseFooter"
>
  <footer>
    <div
      class="footer"
      *ngIf="
        (        globalService.footer.show_secondary_menu &&
          globalService.footer.id_menu_secondary &&
          globalService.footer.title_menu_secondary) ||
        (globalService.footer.show_primary_menu &&
          globalService.footer.id_menu_main &&
          globalService.footer.title_menu_main) ||
        globalService.footer.show_newsletter ||
        globalService.footer.show_data_contact ||
        globalService.footer.show_social_media ||
        globalService.footer.show_logo_tn ||
        globalService.footer.newFile ||
        globalService.footer.logo_url
      "
    >
      <div
        class="logo container"
        *ngIf="globalService.footer.newFile || globalService.footer.logo_url"
      >
        <img
          [src]="globalService.footer.newFile || globalService.footer.logo_url"
          alt=""
        />
      </div>

      <div class="container">
        <!-- ACA VAN LOS DOS MENUES -->
        <div
          class="column"
          *ngIf="
            globalService.footer.show_primary_menu &&
            globalService.footer.id_menu_main &&
            globalService.footer.menu_main?.length &&
            globalService.footer.title_menu_main
          "
        >
          <app-menu-main
            [menu]="globalService.footer.menu_main"
            [title]="globalService.footer.title_menu_main"
          >
          </app-menu-main>
        </div>

        <div
          class="column"
          *ngIf="
            globalService.footer.show_secondary_menu &&
            globalService.footer.id_menu_secondary &&
            globalService.footer.title_menu_secondary &&
            globalService.footer.show_primary_menu &&
            globalService.footer.id_menu_main &&
            globalService.footer.title_menu_main
          "
        >

          <app-menu-main
            [menu]="globalService.footer.menu_secondary"
            [title]="globalService.footer.title_menu_secondary"
          >
          </app-menu-main>
        </div>

        <!-- 1.Si hay menu y data de contacto y (redes sociales, newsletter y logo tn) -->
        <!-- 2.si no hay menu y no hay data de contacto o (redes sociales, newsletter y logo tn) -->
        <!-- 3. si hay menu y no hay data de contacto o (redes sociales, newsletter y logo tn) -->
        <!-- 4. si no hay menu y hay data de contacto  (redes sociales, newsletter y logo tn) -->
        <div
          [ngClass]="
            globalService.footer?.show_primary_menu &&
            globalService.footer?.id_menu_main &&
            globalService.footer?.title_menu_main
              ? 'with-menu'
              : 'not-menues'
          "
          [style]="
            globalService.footer.show_primary_menu &&
            globalService.footer.id_menu_main &&
            globalService.footer.title_menu_main &&
            globalService.footer.show_data_contact &&
            (globalService.footer.show_newsletter ||
              globalService.footer.show_social_media ||
              globalService.footer.show_logo_tn)
              ? 'justify-content:space-around'
              : (!globalService.footer.show_primary_menu ||
                  !globalService.footer.id_menu_main ||
                  !globalService.footer.title_menu_main) &&
                (!globalService.footer.show_data_contact ||
                  (!globalService.footer.show_newsletter &&
                    !globalService.footer.show_social_media &&
                    !globalService.footer.show_logo_tn))
              ? 'justify-content:flex-start'
              : globalService.footer.show_primary_menu &&
                globalService.footer.id_menu_main &&
                globalService.footer.title_menu_main &&
                (!globalService.footer.show_data_contact ||
                  (!globalService.footer.show_newsletter &&
                    !globalService.footer.show_social_media &&
                    !globalService.footer.show_logo_tn))
              ? 'justify-content:flex-end'
              : (!globalService.footer.show_primary_menu ||
                  !globalService.footer.id_menu_main ||
                  !globalService.footer.title_menu_main) &&
                globalService.footer.show_data_contact &&
                (globalService.footer.show_newsletter ||
                  globalService.footer.show_social_media ||
                  globalService.footer.show_logo_tn)
              ? 'justify-content:space-between'
              : ''
          "
        >
          <div
            *ngIf="globalService.footer.show_data_contact"
            class="container-contact"
          >
            <app-contact></app-contact>
          </div>

          <div Class="container-social">
            <app-newsletter
              *ngIf="globalService.footer.show_newsletter"
            ></app-newsletter>

            <app-social-media
              *ngIf="
                globalService.footer.show_social_media ||
                globalService.footer.show_logo_tn
              "
            ></app-social-media>
          </div>
        </div>
      </div>

      <!-- METODOS DE ENVIO Y PAGO -->

      <div class="container methods">
        <div
          class="column column-50"
          *ngIf="globalService.footer.show_method_payment"
        >
          <div class="method-payment">
            <app-method-payment></app-method-payment>
          </div>
        </div>

        <div
          class="column column-50"
          *ngIf="globalService.footer.show_method_shipment"
        >
          <div class="method-shipment">
            <app-method-shipment></app-method-shipment>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="copyright-background">
        <div class="container">
          <div class="creator">
              <p>
                Copyright {{ globalService.website.title }} - {{ currentYear }}.
                Todos los derechos reservados. Defensa de las y los
                consumidores. Para reclamos
                <a
                  target="_blank"
                  href="https://autogestion.produccion.gob.ar/consumidores"
                  >ingresá acá.
                </a>
                /
                <a (click)="globalService.regretBox = true"
                  >Botón de arrepentimiento</a
                >
              </p>

            <div style="display: flex; align-items: center; gap: 10px;">
              <div
                class="list__header"
                *ngIf="!globalService.footer.show_logo_tn"
              >
                <p class="creator_title">Creado con</p>
              </div>
              <div
                class="list__content"
                *ngIf="!globalService.footer.show_logo_tn"
              >
                <a
                  class="creator_logo"
                  href="https://tiendanegocio.com"
                  target="_blank"
                >
                  <app-logo-tn></app-logo-tn>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</ng-container>

<ng-template #purchaseFooter></ng-template>

<ng-template #ViewContainer> </ng-template>